import { Stats } from './stats';
import { User } from './user-model';
import { RuleTestDocument } from './write-rules';

export type List = {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  user?: User;
  name: string;
  description: string;
  tags: string[];
  pathName: string;
  schema: Record<string, any> | null;

  // The list's write rules, and their tests. Only returned to callers allowed
  // to see them: user auth mode, or a token with list update permission
  rules?: string | null;
  rulesTests?: RuleTestDocument | null;

  pinned: boolean;
  readonly: boolean;
  realtime: boolean;
  protected: boolean;
  indexable: boolean;
  generative: boolean;
  generativePrompt: string | null;
  activated: boolean;
  locked?: boolean;
  itemCount?: number;

  // The schema sync scope that manages the list, only when it's fetched with
  // includeScope
  scope?: string | null;
};

export type ListMinimal = {
  id: string;
  name: string;
  pathName: string;
};

export type ListStats = {
  items: Stats<{
    lists: {
      [listId: string]: number;
    };
  }>;
  indexes: Stats<{
    lists: {
      [listId: string]: number;
    };
  }>;
  events: Stats<{
    types: {
      [eventType: string]: number;
    };
  }>;
};

export const listOrderFields = [
  'createdAt',
  'updatedAt',
  'userId',
  'name',
  'pathName',
  'pinned',
  'readonly',
  'realtime',
  'protected',
  'indexable',
  'generative',
  'activated',
] as const;

export type ListOrderField = (typeof listOrderFields)[number];
